// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ximg-fade[data-v-78ead3fe]{position:relative}.layer[data-v-78ead3fe]{position:absolute;inset:0;opacity:0;transition:opacity var(--v11632c95) ease}.layer[data-v-78ead3fe]:first-child{position:relative}.layer.show[data-v-78ead3fe]{opacity:1}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
